import { render, staticRenderFns } from "./index.vue?vue&type=template&id=663ddd6d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=663ddd6d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ddd6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663ddd6d')) {
      api.createRecord('663ddd6d', component.options)
    } else {
      api.reload('663ddd6d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=663ddd6d&scoped=true", function () {
      api.rerender('663ddd6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/profile/index.vue"
export default component.exports